import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eta_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('eta_admin_token');
      localStorage.removeItem('eta_admin_data');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Public APIs
export const getCategories = () => api.get('/categories');
export const getCategory = (id) => api.get(`/categories/${id}`);
export const getServices = (categoryId) => api.get('/services', { params: { category_id: categoryId } });
export const getAllServices = () => api.get('/services');
export const submitContact = (data) => api.post('/contact', data);
export const getContent = (key) => api.get(`/content/${key}`);
export const getAllContent = () => api.get('/content');
export const getSettings = (key) => api.get(`/settings/${key}`);
export const getAllSettings = () => api.get('/settings');

// Admin Auth APIs
export const adminLogin = (data) => api.post('/admin/login', data);
export const adminRegister = (data) => api.post('/admin/register', data);
export const getAdminProfile = () => api.get('/admin/me');

// Admin Category APIs
export const createCategory = (data) => api.post('/admin/categories', data);
export const updateCategory = (id, data) => api.put(`/admin/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/admin/categories/${id}`);

// Admin Service APIs
export const createService = (data) => api.post('/admin/services', data);
export const updateService = (id, data) => api.put(`/admin/services/${id}`, data);
export const deleteService = (id) => api.delete(`/admin/services/${id}`);

// Admin Message APIs
export const getMessages = () => api.get('/admin/messages');
export const markMessageRead = (id) => api.put(`/admin/messages/${id}/read`);
export const deleteMessage = (id) => api.delete(`/admin/messages/${id}`);

// Admin Content APIs
export const updateContent = (key, data) => api.put(`/admin/content/${key}`, data);
export const updateSettings = (key, data) => api.put(`/admin/settings/${key}`, data);

// Admin Statistics
export const getStatistics = () => api.get('/admin/statistics');

// Seed Data
export const seedData = () => api.post('/admin/seed');

export default api;
